import { Button, Form, Input, Select } from 'antd';
import { useEffect, useState } from 'react';
import { usePosts } from './PostsState';
import { useForm } from 'antd/es/form/Form';
import TextEditor from '../../../Components/Macro/TextEditor/TextEditor';
import ImgUpload from '../../../Components/Macro/ImgUpload/ImgUpload';
import FileUpload from '../../../Components/Macro/ImgUpload/FileUpload';

function Edit() {
    let { ed, editPost } = usePosts()
    let [form] = useForm()
    let [body, setBody] = useState('')
    let [userImg, setUserImg] = useState('');
    let [pdf, setPdf] = useState('');

    useEffect(() => {
        form.setFieldsValue(ed)
        setUserImg(ed.img)
        setBody(ed.body)
        setPdf(ed.pdf)
    }, [ed]);

    return (
        <div>
            <Form
                form={form}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={(v) => {
                    editPost({ id: v.id, title: v.title, img: userImg, body: body, pdf: pdf, category: v.category })
                }}
            >
                <Form.Item
                    name={"id"}
                    label="ID"
                    hidden={true}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={"title"}
                    label="Sarlavha"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={'img'}
                    label="Asosiy Rasm"
                >
                    <ImgUpload userImg={userImg} setUserImg={setUserImg} />
                </Form.Item>
                <Form.Item
                    name={'pdf'}
                    label="Maqola PDF fayli"
                >
                    <FileUpload setUserImg={setPdf} />
                </Form.Item>
                <Form.Item name={'category'} label="Kategoriya">
                    <Select options={[{ value: 'Qaror', label: 'Qaror' }, { value: 'Maqola', label: 'Maqola' }]} />
                </Form.Item>
                <Form.Item name={"body"} label="Maqola">
                    <TextEditor height={'550px'} defaultValue={ed.body} onChange={setBody} />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">Saqlash</Button>
                </Form.Item>
            </Form>
        </div>
    );
}

export default Edit;